import { apis } from "./base";

const creditNoteService = apis.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableResellerCredits: builder.query({
      query: (reseller_id) => `/admin/credit-notes/get-available-credits/${reseller_id}`,
      transformResponse: (response) => response.response,
      providesTags: ["CreditNotes", "Quotes"],
    }),
    getAllResellerCredits: builder.query({
      query: (country_id) => `/admin/credit-notes/get/${country_id}`,
      providesTags: ["CreditNotes"],
    }),
    createResellerCredits: builder.mutation({
      query: (data) => ({
        url: `/admin/credit-notes/add`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CreditNotes"],
    }),
    editResellerCredits: builder.mutation({
      query: (data) => ({
        url: `/admin/credit-notes/update/${data.id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["CreditNotes"],
    }),
    deleteResellerCredits: builder.mutation({
      query: (data) => ({
        url: `/admin/credit-notes/delete/${data.id}`,
        method: "DELETE",
        body: {
          countryId: data.countryId,
        },
      }),
      invalidatesTags: ["CreditNotes"],
    }),
    applyCreditnoteToOrder: builder.mutation({
      query: (data) => ({
        url: `/admin/credit-notes/apply/${data.id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CreditNotes"],
    }),
  }),
});

export const {
  useGetAvailableResellerCreditsQuery,
  useLazyGetAvailableResellerCreditsQuery,
  useGetAllResellerCreditsQuery,
  useCreateResellerCreditsMutation,
  useEditResellerCreditsMutation,
  useDeleteResellerCreditsMutation,
  useApplyCreditnoteToOrderMutation,
} = creditNoteService;
